import type { RaidId, RaidSummary } from '../types'

export interface PlannedRaidNeighbors {
  readonly previous: RaidSummary | null
  readonly next: RaidSummary | null
}

/**
 * Finds the adjacent scheduled raids in the store's canonical raid order.
 * Cancelled and completed raids are historical records, not navigation
 * targets for the active planning flow.
 */
export function plannedRaidNeighbors(
  raids: ReadonlyArray<RaidSummary>,
  activeRaidId: RaidId,
): PlannedRaidNeighbors {
  const plannedRaids = raids.filter(
    (raid) => raid.scheduledStartsAt !== null
      && raid.cancelledAt === null
      && raid.completedAt === null,
  )
  const activeIndex = plannedRaids.findIndex((raid) => raid.id === activeRaidId)

  return {
    previous: activeIndex > 0 ? plannedRaids[activeIndex - 1] ?? null : null,
    next: activeIndex >= 0 ? plannedRaids[activeIndex + 1] ?? null : null,
  }
}
